import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const EmptyRecordPage = () => {
  const { t } = useTranslation();

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="item-empty-area text-center">
          <div className="item-empty-area__icon mb-30">
            <i className="pe-7s-shuffle" />
          </div>
          <div className="item-empty-area__text">
            {t("noRecord")}
            <br />
            <Link to={`${process.env.PUBLIC_URL}/browse`}>
              {t("compare.continueShopping")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyRecordPage;
